<template>
    <div
        :class="[
            'mx-auto px-6 pt-4 flex flex-col justify-start items-start bg-white w-full',
            classes,
        ]">
        <div class="flex justify-start items-center gap-1">
            <label
                v-if="label"
                :for="name"
                class="flex flex-wrap items-center gap-1">
                <div
                    class="text-neutral-900 text-base font-bold font-Open w-full">
                    {{ label }}<span v-if="required">*</span>
                    <span
                        v-else
                        class="ml-2 text-sm font-normal"
                        >(optional)</span
                    >
                </div>
            </label>
            <div
                v-if="subtext"
                class="text-neutral-900 text-sm font-normal font-Open leading-tight">
                {{ subtext }}
            </div>
        </div>

        <div class="w-full py-3 flex justify-start items-center gap-1">
            <input
                v-model="currentValue"
                :type="type"
                :class="[
                    'text-neutral-900 font-sm spacing-small py-2.5 px-2 grow shrink w-full basis-0 text-base font-normal font-Open leading-normal rounded border-[1px] ',
                    // Disabled classes:
                    'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-[--colour-theme-background-bg-decorative] disabled:text-[--colour-theme-text-text-mute] disabled:border-[--colour-theme-border-border-alt-weak]',
                    inputClasses,
                    validationMessage
                        ? 'border-red-500 error'
                        : 'border-gray-300', // Added inputClasses to bind custom classes
                ]"
                :disabled="disabled"
                :name="name"
                :placeholder="placeholder"
                :required="required"
                @input="handleFieldChange"
                @blur="handleFieldChange" />
        </div>
        <div
            v-if="validationMessage"
            class="text-red-500 text-sm font-Open w-full">
            {{ validationMessage }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { InputFieldType } from '@/components/ComponentTypes';
    import { useBookingStore } from '@/stores/booking';
    import { useValidationStore } from '@/stores/validation';
    import { computed, ref } from 'vue';

    const { updateBookingState } = useBookingStore();
    const validationStore = useValidationStore();
    const props = defineProps<InputFieldType>();
    const currentValue = ref(props.value);
    const validationMessage = computed(() =>
        validationStore.getError(props.name)
    );

    const handleFieldChange = () => {
        updateBookingState({ [props.name]: currentValue.value });
        validationStore.clearError(props.name);
    };
</script>
